(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[455],{

/***/ 7794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(2723);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var TextGradient = function(param) {
    var children = param.children, _light = param.light, light = _light === void 0 ? false : _light, _overrideClassName = param.overrideClassName, overrideClassName = _overrideClassName === void 0 ? "" : _overrideClassName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            backgroundImage: light ? "linear-gradient(to right, #86EFAC, #67E8F9)" : "linear-gradient(to right, #06B6D4, #22C55E)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            color: "transparent"
        },
        className: "".concat(overrideClassName),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextGradient);


/***/ }),

/***/ 2723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _tmp_build_4e4bf66b_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _tmp_build_4e4bf66b_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_4e4bf66b_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _app_components_gradient_gradient_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3725);
/* harmony import */ var _app_components_form_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2471);
/* harmony import */ var _app_components_phone_input__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(740);
/* harmony import */ var _app_components_text_area__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7698);
/* harmony import */ var _app_components_checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3597);
/* harmony import */ var _app_components_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6625);
/* harmony import */ var _mdi_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(5317);
/* harmony import */ var _mdi_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8849);
/* harmony import */ var _mdi_react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_mdi_react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5249);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2920);
/* harmony import */ var _app_lib_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1895);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}














var ContactUs = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isDisabled = ref[0], setIsDisabled = ref[1];
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(_tmp_build_4e4bf66b_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(payload, form) {
            return _tmp_build_4e4bf66b_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _app_lib_api__WEBPACK_IMPORTED_MODULE_12__/* .frontendApi.post */ .mR.post("/web/get-in-touch", payload).then(function(res) {
                            console.log(payload);
                            react_toastify__WEBPACK_IMPORTED_MODULE_11__/* .toast.success */ .Am.success(res.data.message, {
                                position: "bottom-right"
                            });
                            form.reset();
                            setIsDisabled(true);
                        }).catch(function(err) {
                            return react_toastify__WEBPACK_IMPORTED_MODULE_11__/* .toast.error */ .Am.error("Something went wrong");
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(payload, form) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "md:flex",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "bg-background-low-em pt-10 pb-6 px-6 md:basis-1/2 md:pt-44 md:px-10 xl:!px-20",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "space-y-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "label-sm text-secondary-dark",
                                children: "Contact Us"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_gradient_gradient_text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                overrideClassName: "h5 sm:h4 md:h3",
                                children: "Message our friendly team"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "text-body-lg text-text-color-mid-em",
                                children: "We'd love to hear from you! Please get in touch."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "space-y-6 mt-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex space-x-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_mdi_react__WEBPACK_IMPORTED_MODULE_9___default()), {
                                        path: _mdi_js__WEBPACK_IMPORTED_MODULE_13__/* .mdiMapMarkerOutline */ .CJv,
                                        size: 1,
                                        className: "text-secondary-dark"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "label-lg text-text-color-mid-em",
                                                children: "Plano, TX"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "label-sm text-text-color-low-em",
                                                children: "Visit our Headquarters Office."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "flex space-x-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((_mdi_react__WEBPACK_IMPORTED_MODULE_9___default()), {
                                        path: _mdi_js__WEBPACK_IMPORTED_MODULE_13__/* .mdiEmail */ .XH8,
                                        size: 1,
                                        className: "text-secondary-dark"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "label-lg text-text-color-mid-em break-all",
                                                children: "contact@simplewaste.com"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "label-sm text-text-color-low-em",
                                                children: "Speak to our friendly team"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "p-6 md:basis-1/2 md:py-[70px] md:px-10 xl:py-[90px] xl:px-[120px]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h5", {
                                className: "text-text-color-high-em h5 md:h4",
                                children: "Get in touch"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "text-body-lg text-text-color-mid-em",
                                children: "Got a question? Send us a message and we'll respond as soon as possible."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "mt-4 space-y-6 flex flex-col justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_10__/* .Form */ .l0, {
                            onSubmit: handleSubmit,
                            render: function(param) {
                                var handleSubmit = param.handleSubmit, form = param.form, submitting = param.submitting;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                    onSubmit: handleSubmit,
                                    className: "space-y-6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_form_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            label: "Name",
                                            name: "name"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_form_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            label: "Company",
                                            name: "company"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_form_input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            label: "Email",
                                            name: "email"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_phone_input__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            initialValue: "us",
                                            name: "phone",
                                            label: "Phone Number",
                                            labelClassName: "text-text-color-high-em label-md"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_text_area__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            label: "Message",
                                            name: "message",
                                            labelClassName: "text-text-color-high-em label-md"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_checkbox__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                            checked: !isDisabled,
                                            onChange: function(e) {
                                                return setIsDisabled(!e.target.checked);
                                            },
                                            description: "You agree to our friendly privacy policy."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            type: "submit",
                                            className: "w-full",
                                            disabled: isDisabled,
                                            children: "Send Message"
                                        })
                                    ]
                                });
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ContactUs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(7794); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);